export const serviceGroupOfferOptionsFragment = `
    id
    code
    name
`;
